
import { routes } from "../routes";


export {
};

export default {
    routes,
}
